<dx-popup
  [width]="750"
  [height]="650"
  [showTitle]="true"
  class="transport-intervention-report-popup"
  [title]="title"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [elementAttr]="{ class: 'transport-intervention-realtime-report-popup' }"
  (onHidden)="closed($event)"
  [(visible)]="visible">
  <div *dxTemplate="let data of 'content'">

    <div id="transport-intervention-realtime-report-map" class="transport-intervention-realtime-report-map"
         leaflet
         [leafletOptions]="mapOptions"
         (leafletMapReady)="onMapReady($event)">
    </div>

    <app-map-layers-control [mapReady]="mapReady$" [layers]="layers"></app-map-layers-control>

    <div *ngIf="status">
      <app-transport-interventions-realtime-report-details [item]="status"></app-transport-interventions-realtime-report-details>
    </div>

    <dx-load-panel
      class="route-loading"
      shadingColor="rgba(0,0,0,0.2)"
      [(visible)]="isRouteLoading"
      [showIndicator]="true"
      [showPane]="true"
      [shading]="true"
      [closeOnOutsideClick]="false">
      <div *dxTemplate="let data of 'content'">{{routeLoader.loadedStr()}}</div>
    </dx-load-panel>
  </div>
</dx-popup>

